<template>
  <div>
    <BaseHeadline icon="mdi-account-check-outline" :subtitle="isCompetedText">
    </BaseHeadline>

    <v-alert v-if="activities.length === 0 && !loadingActivities" type="info">
      <v-row align="center">
        <v-col class="grow"> Denne egenkontollen har ingen aktiviteter! </v-col>
        <v-col class="shrink">
          <v-btn color="album" @click="completeSchedule">Ferdigstill</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <BaseView v-model="list" class="mt-2">
      <template v-slot="{ element }">
        <CheckupInfoCard
          v-if="element.type === 'CheckupInfoCard'"
          :schedule="schedule"
          :activities="activities"
        />
        <CheckupActivities
          v-if="element.type === 'CheckupActivities'"
          :activities.sync="activities"
          @updateActivities="convertBlueprintsDirectives"
        />
      </template>
    </BaseView>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";
import scheduleApi from "@/api/scheduleApi";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import BaseView from "@/components/shared/BaseView.vue";
import CheckupInfoCard from "@/components/checkups/checkup/children/CheckupInfoCard.vue";
import CheckupActivities from "@/components/checkups/checkup/children/CheckupActivities.vue";
import notification from "@/helpers/notification";

export default Vue.extend({
  data() {
    return {
      schedule: {},
      activities: [],
      loadingActivities: true,
      list: {
        lg: [[{ type: "CheckupInfoCard" }], [{ type: "CheckupActivities" }]],
        md: [[{ type: "CheckupInfoCard" }], [{ type: "CheckupActivities" }]],
        sm: [[{ type: "CheckupInfoCard" }, { type: "CheckupActivities" }]],
      },
    };
  },

  async mounted() {
    this.loadingActivities = true;
    var scheduleId = this.$route.params.id;
    await scheduleApi.getSchedule(scheduleId).then((x) => {
      this.schedule = x.schedule;
    });

    await scheduleApi.getActivities(scheduleId).then((x) => {
      this.convertBlueprintsDirectives(x);
      this.loadingActivities = false;
    });
  },

  methods: {
    convertBlueprintsDirectives(activities) {
      activities.forEach((x) => {
        var text = x.text.replace(/ibm-blob-link/gi, "v-ibm-blob-link");
        var faqanswer = "<div>" + text + "</div>";
        x.text = faqanswer;
      });

      this.activities = activities;
    },
    async completeSchedule() {
      var scheduleId = this.$route.params.id;
      await scheduleApi.completeSchedule(scheduleId).then(() => {
        this.$router.push({ name: "Checkups" });
        notification.success("Egenkontoller fullført");
      });
    },
  },

  computed: {
    isCompetedText(): string {
      if ((this as any).schedule.completedDate) {
        return (
          "Ferdigmeldt " +
          moment((this as any).schedule.completedDate).format("DD.MM.YYYY")
        );
      }
      return "";
    },
  },

  components: {
    BaseView,
    BaseHeadline,
    CheckupInfoCard,
    CheckupActivities,
  },
});
</script>
